const formatPromptType = (type: string) => {
  return type.charAt(0).toUpperCase() + type.slice(1) + ' prompt';
};

export default formatPromptType;
